import { render, staticRenderFns } from "./Uppgifter2.vue?vue&type=template&id=f21d8aee&"
import script from "./Uppgifter2.vue?vue&type=script&lang=js&"
export * from "./Uppgifter2.vue?vue&type=script&lang=js&"
import style0 from "./Uppgifter2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports